import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

// Clickable YOKOLICIOUS logo shown top-left of every authenticated layout.
// Routes to the dashboard appropriate for the current portal, closes the mobile
// drawer if one is open, and swaps to the compact eagle mark when collapsed.
export const BrandLogo = ({ collapsed = false, onNavigate, className = "" }) => {
  const { user } = useAuth();
  const home = user?.active_portal === "STAFF" ? "/employee" : "/management";

  return (
    <Link
      to={home}
      onClick={onNavigate}
      aria-label="YOKOLICIOUS Home"
      data-testid="brand-logo-link"
      className={`flex items-center gap-2 shrink-0 rounded-lg outline-none focus-visible:ring-2 focus-visible:ring-red-500 transition-opacity hover:opacity-80 ${className}`}
    >
      {collapsed ? (
        <img src="/yokolicious-eagle-salute.png" alt="YOKOLICIOUS" className="h-9 w-9 object-contain" data-testid="brand-logo-mark" />
      ) : (
        <>
          <img src="/yokolicious-eagle-salute.png" alt="" className="h-9 w-9 object-contain shrink-0" data-testid="brand-logo-mark" />
          <img src="/yokolicious-wordmark.png" alt="YOKOLICIOUS" className="h-7 object-contain" data-testid="brand-logo-wordmark" />
        </>
      )}
    </Link>
  );
};
